import { render, staticRenderFns } from "./SocialIconLink.vue?vue&type=template&id=f2146b36"
import script from "./SocialIconLink.vue?vue&type=script&lang=js"
export * from "./SocialIconLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports